(function () {
  'use strict';

  var S = window.sxStrings || {};

  /* ---- Direkt in den Warenkorb von der Produktkarte ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button.card__add[data-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var text = btn.textContent;
    btn.disabled = true;
    btn.textContent = S.adding || 'Wird hinzugefügt';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.add, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = S.added || 'Im Warenkorb';
        var link = document.querySelector('a[href$="/cart"]');
        if (link) link.click();
        setTimeout(function () { btn.textContent = text; btn.disabled = false; }, 1400);
      })
      .catch(function () {
        window.location.href = btn.closest('.card').querySelector('.card__link').href;
      });
  });

  /* ---- Abschnitte sanft einblenden ---- */
  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduziert || !('IntersectionObserver' in window)) return;

  var ziele = document.querySelectorAll('.section .card, .section-head, .quote p, .trust__item, .related .card');
  if (!ziele.length) return;

  document.documentElement.classList.add('reveal-on');
  var io = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (eintrag) {
      if (!eintrag.isIntersecting) return;
      eintrag.target.classList.add('is-in');
      io.unobserve(eintrag.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  Array.prototype.forEach.call(ziele, function (el, i) {
    el.style.setProperty('--reveal-delay', (i % 6) * 55 + 'ms');
    io.observe(el);
  });
})();
